import { FALSE, TRUE } from "constants/primitives";

const shouldResetConsent = (
  timestamp: number | string | null,
  lastConsentReset: number | null
) => {
  if (!lastConsentReset || typeof lastConsentReset !== "number") {
    return FALSE;
  }

  const ts = parseInt(timestamp as string);
  if (timestamp && !isNaN(ts) && ts >= lastConsentReset) {
    return FALSE;
  }

  return TRUE;
};

export default shouldResetConsent;
